import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../Helpers/RgbColorHelper";

export default function Detail_Textual_L_Bar({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Find the hit range to display on the right
  const hitRange = item.scale.ranges.find((range) => range.isHit);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper only if RGB is enabled
  const colors = rgbEnabled ? getScaleColors(item.scale) : null;

  // Default colors
  const progressColor = rgbEnabled ? colors.primary : "#4a90e2";
  const backgroundColor = rgbEnabled ? colors.light : "#e0e0e0";

  return (
    <Row className={"mb-2 mx-0"}>
      <div className="p-3" style={{ border: "1px solid #e0e0e0", borderRadius: "8px", backgroundColor: "#fff" }}>
        {/* Main layout */}
        <Row className="align-items-stretch">
          {/* Left side - Scope name, Item name, Loading bar with percentage */}
          <Col xs={5}>
            {/* Scope name (only if isSub) */}

            {/* Item name */}
            <div
              style={{
                fontSize: "20px",
                fontWeight: "600",
                color: rgbEnabled ? colors.dark : "#333",
                marginBottom: "5px",
              }}
            >
              {item.name}
              {!item.isSub && item.scopeName && (
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#acacacff",
                    textTransform: "uppercase",
                    marginLeft: "8px",
                  }}
                >
                  ({item.scopeName})
                </span>
              )}
            </div>

            {/* Loading bar with percentage */}
            <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "15px" }}>
              {/* Percentage text */}
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: rgbEnabled ? colors.dark : "#333",
                  minWidth: "65px",
                }}
              >
                {elementScore}%
              </div>

              {/* Loading bar */}
              <div
                style={{
                  flex: 1,
                  height: "36px",
                  backgroundColor: backgroundColor,
                  borderRadius: "18px",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: `${elementScore}%`,
                    backgroundColor: progressColor,
                    borderRadius: "18px",
                    transition: "width 0.3s ease",
                  }}
                />
              </div>
            </div>
          </Col>

          {/* Right side - Hit range text */}
          <Col xs={7} className="pe-4">
            {hitRange &&
              (item.scale.isHtml ? <div dangerouslySetInnerHTML={{ __html: hitRange.text }} /> : hitRange.text)}
          </Col>
        </Row>
      </div>
    </Row>
  );
}
